import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query'; 
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function SignUpHusbandDetails() {

  const { menu, toggleMobileMenu } = useAppLayout();
  
  const navigate = useNavigate();
   
      const [isSubmitting, setIsSubmitting] = useState(false);

      


      const [husbandDetails, setHusbandDetails] = useState({
        first_name: '',
        last_name: '',
        status: false,     // deceased
        inactive: false,   // inactive
        email: '',
        phone_number: ''
      });

      const showContact = !husbandDetails.status && !husbandDetails.inactive;
      
      const [isSubmittingM, setIsSubmittingM] = useState(false);

      
      
            const handleGoBack = () => {
              setIsSubmitting(true);
            
              axios.post(
                `${API_URL}/cancel-husband-details-api`,
                {},  
                { withCredentials: true }
              )
                .then(() => {
                  toast.success("Gender cancelled successfully");
                  navigate('/sign-up-category');
                })
                .catch(() => {
                  toast.error("Failed to cancel gender");
                })
                .finally(() => setIsSubmitting(false));
            };
      

      
      const handleCheckboxChange = (field) => {
        setHusbandDetails((prev) => ({
          ...prev,
          [field]: !prev[field]
        }));
      };
      
      const handleFamilyMarriedSubmit = async () => {
        if (!husbandDetails.first_name.trim() || !husbandDetails.last_name.trim()) {
          toast.error("Fill empty fields.");
          return;
        }
      
        setIsSubmittingM(true);
      
        try {
          const payload = {
            ...husbandDetails,
            ...(husbandDetails.status || husbandDetails.inactive
              ? { email: '', phone_number: '' }
              : {})
          };
      
          const res = await axios.post(
            `${API_URL}/reg-signup-family-married-update-api`,
            payload,
            { withCredentials: true }
          );
      
          if (res.data.Status === "Success") {
            navigate(res.data.redirect);

          } else {
            toast.error("Failed to submit.");
          }
        } catch (error) {
          console.error("Family update failed:", error);
          toast.error("Something went wrong.");
        } finally {
          setIsSubmittingM(false);
        }
      };
      


    return (
        
         <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

          <div className="row justify-content-center">
      <div className="col-12 col-md-8">
        <div
          className="rounded-4 border-0"
          style={{
            background: "#ffffff",
            boxShadow: "0 2px 18px rgba(13,110,40,0.08)",
          }}
        >
          
          {/* Header */}
          <div
            className="px-4 py-3 rounded-top-4"
            style={{ background: "#184A2C" }}
          >
            <p className="mb-0 fw-semibold text-center" style={{ color: "#ffffff", fontSize: 15 }}>
              Husband's details
            </p>
          </div>
 
          {/* Body */}
          <div className="p-3 p-md-4">
            {/* Name row */}
            <div className="row g-3">
              <div className="col-6">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: 13, fontWeight: 500, color: "#3a3f3b" }}
                >
                  First name
                </label>
                <input
                  type="text"
                  name="first_name"
                  className="form-control"
                  required
                  value={husbandDetails.first_name}
                  onChange={(e) =>
                    setHusbandDetails({ ...husbandDetails, first_name: e.target.value })
                  }
                  style={inputStyle}
                  onFocus={focusStyle}
                  onBlur={blurStyle}
                />
              </div>
              <div className="col-6">
                <label
                  className="form-label mb-1"
                  style={{ fontSize: 13, fontWeight: 500, color: "#3a3f3b" }}
                >
                  Last name
                </label>
                <input
                  type="text"
                  name="last_name"
                  className="form-control"
                  required
                  value={husbandDetails.last_name}
                  onChange={(e) =>
                    setHusbandDetails({ ...husbandDetails, last_name: e.target.value })
                  }
                  style={inputStyle}
                  onFocus={focusStyle}
                  onBlur={blurStyle}
                />
              </div>
            </div>
 
            {/* Contact row - only if not deceased/inactive */}
            {showContact && (
              <div className="row g-3 mt-1">
                <div className="col-6">
                  <label
                    className="form-label mb-1"
                    style={{ fontSize: 13, fontWeight: 500, color: "#3a3f3b" }}
                  >
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    value={husbandDetails.email}
                    onChange={(e) =>
                      setHusbandDetails({ ...husbandDetails, email: e.target.value })
                    }
                    style={inputStyle}
                    onFocus={focusStyle}
                    onBlur={blurStyle}
                  />
                </div>
                <div className="col-6">
                  <label
                    className="form-label mb-1"
                    style={{ fontSize: 13, fontWeight: 500, color: "#3a3f3b" }}
                  >
                    Phone number
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={husbandDetails.phone_number}
                    onChange={(e) =>
                      setHusbandDetails({ ...husbandDetails, phone_number: e.target.value })
                    }
                    style={inputStyle}
                    onFocus={focusStyle}
                    onBlur={blurStyle}
                  />
                </div>
              </div>
            )}
 
            {/* Status toggles */}
            <div className="d-flex gap-2 mt-4 flex-wrap">
              <StatusPill
                id="deceased"
                label="Deceased"
                checked={husbandDetails.status}
                onChange={() =>
                  setHusbandDetails({
                    ...husbandDetails,
                    status: !husbandDetails.status,
                    inactive: false,
                  })
                }
              />
              <StatusPill
                id="inactive"
                label="Inactive"
                checked={husbandDetails.inactive}
                onChange={() =>
                  setHusbandDetails({
                    ...husbandDetails,
                    inactive: !husbandDetails.inactive,
                    status: false,
                  })
                }
              />
            </div>
 
            {/* Actions */}
            <div className="d-flex justify-content-between align-items-center mt-4">
              <button
                onClick={handleGoBack}
                className="btn rounded-3 px-3 py-2"
                disabled={isSubmitting}
                style={{
                  border: "1.5px solid #d8ded9",
                  background: "#ffffff",
                  color: "#3a3f3b",
                }}
              >
                Back
              </button>
 
              <button
                onClick={handleFamilyMarriedSubmit}
                type="submit"
                disabled={isSubmittingM}
                className="btn rounded-3 px-4 py-2 d-inline-flex align-items-center justify-content-center fw-medium"
                style={{
                  minWidth: 120,
                  background: "#184A2C",
                  border: "none",
                  color: "#fff",
                  transition: "background 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  if (!isSubmittingM) e.currentTarget.style.background = "#75B437";
                }}
                onMouseLeave={(e) => {
                  if (!isSubmittingM) e.currentTarget.style.background = "#184A2C";
                }}
              >
                {isSubmittingM ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    />
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </div>
        </div>
 
        <div style={{ height: 8 }} />
      </div>
    </div>
                                    
          </div>
        </div>


 
      
      </div>
    
    );
}

export default SignUpHusbandDetails;



/* --- Small styled toggle pill used for Deceased / Inactive --- */
function StatusPill({ id, label, checked, onChange }) {
  return (
    <label
      htmlFor={id}
      className="d-flex align-items-center gap-2 rounded-3"
      style={{
        cursor: "pointer",
        padding: "8px 14px",
        border: checked ? "1.5px solid #184A2C" : "1.5px solid #e3e8e4",
        background: checked ? "rgba(117,180,55,0.10)" : "#ffffff",
        transition: "all 0.15s ease",
      }}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={onChange}
        className="d-none"
      />
      <span
        className="rounded-circle flex-shrink-0"
        style={{
          width: 18,
          height: 18,
          border: checked ? "none" : "1.5px solid #cfd6d1",
          background: checked ? "#75B437" : "transparent",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {checked && (
          <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
            <path
              d="M5 13l4 4L19 7"
              stroke="#ffffff"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </span>
      <span style={{ fontSize: 14, fontWeight: 500, color: checked ? "#184A2C" : "#3a3f3b" }}>
        {label}
      </span>
    </label>
  );
}
 
const inputStyle = {
  border: "1.5px solid #e3e8e4",
  borderRadius: 10,
  padding: "8px 12px",
  fontSize: 14.5,
  outline: "none",
  transition: "border-color 0.15s ease",
};
 
function focusStyle(e) {
  e.currentTarget.style.borderColor = "#75B437";
}
 
function blurStyle(e) {
  e.currentTarget.style.borderColor = "#e3e8e4";
}
